// src/components/homepage/FeatureSection.js
import { ClipboardList, CreditCard, Video, ArrowRight } from "lucide-react";

function FeatureSection() {
  const steps = [
    {
      icon: ClipboardList,
      title: "Describe your issue & submit logs",
      description:
        "Tell us what's broken and attach your logs. Automated triage checks scope before payment — no wasted time.",
    },
    {
      icon: CreditCard,
      title: "Pay the transparent flat fee",
      description:
        "No hourly rates. No surprises. €149–€349 depending on your stack. Fixed or fully refunded within scope.",
    },
    {
      icon: Video,
      title: "Expert on screen within 2 hours",
      description:
        "A vetted payment specialist accepts your ticket, reviews your triage notes, and joins a private live video bridge within 120 minutes to resolve the issue on screen.",
    },
  ];

  const stats = [
    { value: "< 120 min", label: "Guaranteed response window" },
    { value: "€149", label: "Starting fixed price" },
    { value: "60 min", label: "Average live session" },
    { value: "48 hr", label: "Post-fix warranty" },
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            How it works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            From broken payments to verified resolution in three simple steps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                className="group relative bg-white rounded-xl p-8 border border-slate-200 hover:border-slate-300 transition"
              >
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-slate-900 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {index + 1}
                </div>

                <div className="w-14 h-14 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-blue-600" />
                </div>

                <h3 className="text-xl font-bold text-slate-900 mb-3">{step.title}</h3>
                <p className="text-slate-600 leading-relaxed">{step.description}</p>

                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 text-slate-300 group-hover:text-blue-500 transition">
                    <ArrowRight className="w-8 h-8" />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 bg-white rounded-2xl border border-slate-200 p-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-blue-600 mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-slate-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeatureSection;
